import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import { Link, withRouter } from "react-router-dom";
import { Translate, I18n } from "react-redux-i18n";
import _ from "lodash";
import Layout from "../../Layouts/LayoutLogin";
import Constants from "../../AppConstants/Constants";
import { getXsrfToken } from "../../Store/Security/Actions";
import { login, guestLogin } from "../../Store/Account/Actions";
import { toggleBlockingStatus } from "../../Store/Status/Actions";
import { Container } from "../../Components/Common/Container";

class LoginPage extends Component {
    constructor(props) {
        super(props);

        this.renderTextField = this.renderTextField.bind(this);
    }

    componentDidMount() {
        const forms = document.getElementsByClassName("login-form-fields");
        const top = _.maxBy(forms, el => el.offsetTop).offsetTop;

        _.each(forms, el => {
            el.style.paddingTop = `${top - el.offsetTop + 20}px`;
        });
    }

    renderTextField(field) {
        const { meta: { touched, error } } = field;
        const className = touched && error ? "has-error" : "";

        return (
            <div className={className}>
                <input type={field.type} placeholder={field.placeholder} {...field.input} onKeyUp={e => this.onInputChange(e.target)} />
                <span className="help-block float-left">{touched ? error : ""}</span>
            </div>
        );
    }

    onInputChange(target) {
        const { untouch } = this.props;

        // eslint-disable-next-line prefer-destructuring
        const contractNumber = document.getElementsByName("ContractNumber")[0];
        // eslint-disable-next-line prefer-destructuring
        const employeeId = document.getElementsByName("employeeId")[0];
        // eslint-disable-next-line prefer-destructuring
        const userName = document.getElementsByName("UserName")[0];
        // eslint-disable-next-line prefer-destructuring
        const password = document.getElementsByName("Password")[0];

        switch (target.name) {
        case "ContractNumber":
            if (target.value.trim().length > 0 || employeeId.value.trim().length > 0) {
                userName.disabled = true;
                password.disabled = true;

                untouch("UserName");
                untouch("Password");
            } else {
                userName.disabled = false;
                password.disabled = false;
            }
            break;
        case "employeeId":
            if (target.value.trim().length > 0 || contractNumber.value.trim().length > 0) {
                userName.disabled = true;
                password.disabled = true;

                untouch("UserName");
                untouch("Password");
            } else {
                userName.disabled = false;
                password.disabled = false;
            }
            break;
        case "UserName":
            if (target.value.trim().length > 0 || password.value.trim().length > 0) {
                contractNumber.disabled = true;
                employeeId.disabled = true;

                untouch("ContractNumber");
                untouch("employeeId");
            } else {
                contractNumber.disabled = false;
                employeeId.disabled = false;
            }
            break;
        case "Password":
            if (target.value.trim().length > 0 || userName.value.trim().length > 0) {
                contractNumber.disabled = true;
                employeeId.disabled = true;

                untouch("ContractNumber");
                untouch("employeeId");
            } else {
                contractNumber.disabled = false;
                employeeId.disabled = false;
            }
            break;
        }
    }

    renderErrors() {
        if (this.props.loginStatus.response) {
            const { response: { data } } = this.props.loginStatus;
            if (data) {
                this.props.toggleBlockingStatus(false);

                return <div className="col-md-12">
                    <div className="alert bg--error" style={{ marginBottom: 0 }}>
                        <div className="alert__body">
                            <span>{data}</span>
                        </div>
                    </div>
                </div>;
            }
        }
    }

    onSubmit(values) {
        const { getXsrfToken, login, guestLogin, reset, toggleBlockingStatus } = this.props;

        toggleBlockingStatus(true);

        getXsrfToken(({ token }) => {
            values.__RequestVerificationToken = token;

            if (values.UserName) {
                login(values, onSuccess);
            } else {
                guestLogin(values, onSuccess);
            }
        });

        function onSuccess() {
            // eslint-disable-next-line prefer-destructuring
            const contractNumber = document.getElementsByName("ContractNumber")[0];
            // eslint-disable-next-line prefer-destructuring
            const employeeId = document.getElementsByName("employeeId")[0];
            // eslint-disable-next-line prefer-destructuring
            const userName = document.getElementsByName("UserName")[0];
            // eslint-disable-next-line prefer-destructuring
            const password = document.getElementsByName("Password")[0];

            if (contractNumber) {
                contractNumber.disabled = false;
            }
            if (employeeId) {
                employeeId.disabled = false;
            }
            if (userName) {
                userName.disabled = false;
            }
            if (password) {
                password.disabled = false;
            }

            reset();
            toggleBlockingStatus(false);
        }
    }

    render() {
        const { handleSubmit, pristine, submitting } = this.props;

        return (
            <Layout>
                <div className="nav-container ">
                    <nav className="bar bar-4 bar--transparent bar--absolute" data-fixed-at="200">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 offset-lg-3 col-md-2 col-md-offset-0 col-4">
                                    <div className="bar__module text-center">
                                        <Link to="#" style={{ cursor: "auto" }}>
                                            <img className="logo logo-light logo-mobile" alt="logo" src={require("../../../Assets/Images/logo-white.png")}/>
                                            <img className="logo logo-light logo-desktop" alt="logo" src={require("../../../Assets/Images/logo-velocitor.png")}/>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
                <Container>
                    <section className="feature-large height-100">
                        <div className="container pos-vertical-center">
                            <div className="row">
                                <div className="col-xl-8 offset-xl-2 col-lg-9 offset-lg-1 col-md-6 offset-md-3">
                                    <form id="login-form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                        <div className="row">
                                            <div className="col-lg-6 col-sm-12">
                                                <h2 className="text-center"><Translate value="login.new.title" /></h2>
                                                <p className="lead text-center"><Translate value="login.new.description" /></p>
                                                <div className="row login-form-fields">
                                                    <div className="col-12">
                                                        <Field
                                                            placeholder={I18n.t("login.new.form.field1")}
                                                            name="employeeId"
                                                            type="text"
                                                            component={this.renderTextField}
                                                        />
                                                    </div>
                                                    <div className="col-12">
                                                        <Field
                                                            placeholder={I18n.t("login.new.form.field2")}
                                                            name="ContractNumber"
                                                            type="text"
                                                            component={this.renderTextField}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="line"></div>
                                            <div className="wordwrapper">
                                                <div className="word"><Translate value="login.or" /></div>
                                            </div>
                                            <hr data-title="OR" />

                                            <div className="col-lg-6 col-sm-12">
                                                <h2 className="text-center"><Translate value="login.existing.title" /></h2>
                                                <p className="lead text-center"><Translate value="login.existing.description" /></p>
                                                <div className="row login-form-fields">
                                                    <div className="col-12">
                                                        <Field
                                                            placeholder={I18n.t("login.existing.form.field1")}
                                                            name="UserName"
                                                            type="email"
                                                            component={this.renderTextField}
                                                        />
                                                    </div>
                                                    <div className="col-12">
                                                        <Field
                                                            placeholder={I18n.t("login.existing.form.field2")}
                                                            name="Password"
                                                            type="password"
                                                            component={this.renderTextField}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            {this.renderErrors()}
                                            <div className="col-lg-6 offset-lg-3 col-sm-12 offset-sm-0">
                                                <button type="submit" className="btn btn--primary type--uppercase" disabled={pristine || submitting}><Translate value="login.btn" /></button>
                                            </div>
                                            <div className="col-lg-10 offset-lg-1 col-md-12 text-center">
                                                <div className="row">
                                                    <div className="col-4">
                                                        <span className="type--fine-print">
                                                            <Link to={Constants.ENDPOINTS.PASSWORD_RECOVERY}><Translate value="login.links.forgotPassword" /></Link>
                                                        </span>
                                                    </div>
                                                    <div className="col-4">
                                                        <span className="type--fine-print">
                                                            <Link to={Constants.ENDPOINTS.SUPPORT}><Translate value="login.links.assistance" /></Link>
                                                        </span>
                                                    </div>
                                                    <div className="col-4">
                                                        <span className="type--fine-print">
                                                            <Link to={Constants.ENDPOINTS.PRIVACY_POLICY}><Translate value="login.links.privacy" /></Link>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                </Container>
            </Layout>
        );
    }
}

LoginPage.propTypes = {
    getXsrfToken: PropTypes.func,
    login: PropTypes.func,
    guestLogin: PropTypes.func,
    toggleBlockingStatus: PropTypes.func,
    handleSubmit: PropTypes.func,
    change: PropTypes.func,
    untouch: PropTypes.func,
    reset: PropTypes.func,
    i18n: PropTypes.object,
    userInfo: PropTypes.object,
    loginStatus: PropTypes.object,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        userInfo: state.userInfo,
        loginStatus: state.loginStatus
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        login: login,
        guestLogin: guestLogin,
        toggleBlockingStatus: toggleBlockingStatus
    }, dispatch);
}

function validate(values) {
    const errors = {};

    if (!values.ContractNumber && !values.UserName && !values.Password) {
        errors.ContractNumber = I18n.t("validation.login.contractNumber.required");
    } else if (values.UserName || values.Password) {
        errors.ContractNumber = null;
    }

    if (!values.employeeId && !values.UserName && !values.Password) {
        errors.employeeId = I18n.t("validation.login.employeeId.required");
    } else if (values.UserName || values.Password) {
        errors.employeeId = null;
    }

    if (!values.UserName && !values.ContractNumber && !values.employeeId) {
        errors.UserName = I18n.t("validation.login.username.required");
    } else if (values.ContractNumber || values.employeeId) {
        errors.UserName = null;
    }

    if (!values.Password && !values.ContractNumber && !values.employeeId) {
        errors.Password = I18n.t("validation.login.password.required");
    } else if (values.ContractNumber || values.employeeId) {
        errors.Password = null;
    }

    return errors;
}

export default reduxForm({
    validate,
    form: "Login"
})(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginPage))
);